import cn from 'classnames';

import Chicken from 'components/icons/illustrative/Chicken';
import Fish from 'components/icons/illustrative/Fish';
import MeatballSub from 'components/icons/illustrative/MeatballSub';
import Pan from 'components/icons/illustrative/Pan';
import Pasta from 'components/icons/illustrative/Pasta';
import RiceBowl from 'components/icons/illustrative/RiceBowl';
import Steak from 'components/icons/illustrative/Steak';
import Taco from 'components/icons/illustrative/Taco';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import useAnalyticsEffect from 'hooks/useAnalyticsEffect';
import { POPULAR_SEARCHES, TEMPO } from 'lib/constants';
import style from 'styles/components/menuSearch/MealsNotFound';

const MealsNotFound = ({ handleSearch, mealPlanSlug, searchTerm }) => {
  useAnalyticsEffect(
    ({ logEvent, events }) => {
      logEvent(events.menuSearch.recipeSearchNoResultsViewed, {
        searchTerm: searchTerm,
        mealPlanSlug: mealPlanSlug,
      });
    },
    [mealPlanSlug]
  );

  const handleSearchWithAnalytics = useAnalyticsCallback(
    search => handleSearch({ params: { searchTerm: search } }),
    ({ logEvent, events, callbackArgs }) =>
      logEvent(events.menuSearch[`recipeSearch${callbackArgs[0].replace(/ /g, '')}Clicked`], {
        search_term: searchTerm,
        mealPlanSlug: mealPlanSlug,
      }),
    [searchTerm, mealPlanSlug]
  );
  const isTempo = mealPlanSlug === TEMPO;

  const noResultsFound = POPULAR_SEARCHES[mealPlanSlug];

  const iconMapping = {
    beef: Steak,
    chicken: Chicken,
    meatballs: MeatballSub,
    'one-pan meals': Pan,
    pasta: Pasta,
    'rice bowl': RiceBowl,
    'steak strips': Steak,
    salmon: Fish,
    tacos: Taco,
  };

  const getIcon = search => {
    return iconMapping[search.toLowerCase()];
  };

  return (
    <div className="flex justify-center">
      <div className="w-5/6 p-6 text-center">
        <h3 className="h4 mb-2">
          We couldn't find any {mealPlanSlug === TEMPO ? 'meals' : 'recipes'} matching "{searchTerm}
          "
        </h3>
        <h4 className={cn(style.menuSearchAgain, 'text mb-8', { tempo: isTempo })}>
          Search again or try one of these popular searches:
        </h4>
        <div className="bp-1:mb-12 mb-8 flex flex-wrap justify-center bp1:flex-row bp1:justify-center">
          {noResultsFound.map(search => {
            const Icon = getIcon(search);
            return (
              <button
                onClick={() => handleSearchWithAnalytics(search)}
                className={cn(
                  style.popularRecipeButton,
                  'btn btnSm mb-2 ml-1 h-10 whitespace-nowrap rounded-full border-none bg-charcoal-50 px-3 text-charcoal-100 hover:bg-charcoal-60'
                )}
                key={`popular-search-button-${search}`}
              >
                {Icon && <Icon className="icon iconMd mb-1 mr-1" />}
                {search}
              </button>
            );
          })}
        </div>
        <h4 className={cn(style.menuSearchAgain, { 'tempo text': isTempo })}>
          Have questions about our products and service?{' '}
          <a
            className="linkTextPrimary"
            href="https://support.homechef.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            View our FAQs
          </a>
        </h4>
      </div>
    </div>
  );
};

MealsNotFound.propTypes = {
  searchTerm: PropTypes.string,
  handleSearch: PropTypes.func.isRequired,
  mealPlanSlug: PropTypes.string.isRequired,
};

export default MealsNotFound;
